export const entityName = 'Teachers';

export const addButtonDisabledTooltipMessage =
	'To add a new Teacher, please contact Customer Support support@esgisoftware.com';
